import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import Navbar from './components/Navbar';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

// import Projects from './components/Projects';
// import About from './components/About';
// import Achievements from './components/Achievements';
// import Resume from './components/resume';
// import Footer from './components/Footer';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
  <BrowserRouter>
  <Navbar/>
  <Routes>
  <Route path="/" element={ <App  Name="Head"/> }/>
  <Route path="/project" element={ <App  Name="Projects" /> }/>
  <Route path="/about" element={  <App  Name="About" /> }/>
  <Route path="/achievements" element={  <App  Name="Achievements" /> }/>
  <Route path="/resume" element={  <App  Name="Resume" /> }/>
  <Route path="/contact" element={  <App  Name="Footer" /> }/>
  </Routes>
  </BrowserRouter>  
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
